import useAnimatedDots from '../../hooks/ui/useAnimatedDots';

const ActionStatusText = ({
    isProcessing,
    isCompleted,
    processingLabel = 'Sparar',
    successLabel = 'Måltid sparad!',
    defaultLabel = 'Spara till matdagbok'
}) => {
    const animatedDots = useAnimatedDots(isProcessing);

    if (isProcessing)
        return (
            <span className="saving-text">
                {processingLabel}
                <span className="saving-dots">{animatedDots}</span>
            </span>
        );

    if (isCompleted) return <span className="success-text">{successLabel}</span>;

    return <>{defaultLabel}</>;
};

export default ActionStatusText;
